<template>
  <div class="buscarReservaBookingSolicitados">

    <Button
      :size="17"
      color="orange"
      colorText="#ffffff"
      tooltip="Buscar reserva / Shipping Instruction"
      icon="fas fa-search"
      round
      :width="35"
      class="ml-3 mr-1"
      style="margin-top:8px"
      traslate
      @click.native="openModal('buscarReservaModal')"
    />

    <ui-modal
      ref="buscarReservaModal"
      title="Buscar reserva / Shipping Instruction"
      @close="cerrarModal"
      size="large"
      id="buscarReservaBookingSolicitados"
    >

      <ui-tabs fullwidth ref="tabs">

        <!-- Tab 1 -->
        <ui-tab title="Reservas" id="1">

          <div class="d-flex flex-column">
            <div>
              <div class="d-flex">
                <div class="w-50 mr-2">
                  <div class="d-flex flex-column mt-2 w-100" >

                    <fieldset-component texto="Parámetros de Búsqueda"/>

                    <div class="d-flex mt-3 w-100">

                      <ui-select
                        class="w-50 ml-2"
                        label="Tipos de Búsqueda (*)"
                        placeholder="Seleccionar"
                        :options="[
                          'Por ID de Reserva',
                          'Por N° de Booking',
                          'Por N° de Contenedor',
                          'Por N° de BL'
                          ]"
                        v-model="busquedaSeleccionadaModel"
                        @change="busquedaSeleccionada(busquedaSeleccionadaModel)"
                      />

                      <ui-textbox
                        class="w-50 ml-3"
                        enforce-maxlength
                        floating-label
                        help="Máximo 20 caracteres"
                        :label="'Buscar Por N° de ' + tipoSeleccionado"
                        error="Campo requerido"
                        :invalid="campoVacio"
                        v-model="buscarModel"
                        :maxlength="20"
                        @keyup.enter.native="realizarBusqueda"
                      />

                      <Button
                        :size="17"
                        color="#28a745"
                        colorText="#ffffff"
                        tooltip="Buscar reserva"
                        icon="fas fa-search"
                        class="mx-4 mt-3"
                        round
                        :width="35"
                        traslate
                        @click.native="realizarBusqueda(busquedaSeleccionadaModel)"
                      />

                    </div>

                  </div>
                </div>

                <!-- Modulo Resultado -->
                <div class="w-50 ml-2">

                  <div class="d-flex flex-column mt-2">
                    <fieldset-component texto="Resultado de Búsqueda"/>

                    <div class="mt-3 px-2">

                      <table-skeleton v-if="isLoading" :numberRows="1" :headers="['ID', 'Cliente', 'POL Sugerido', 'POD']"/>

                      <table v-else class="table table-striped table-hover bordeTabla">
                        <thead>
                        <th class="text-center">ID</th>
                        <th class="text-center">Cliente</th>
                        <th class="text-center">POL Sugerido</th>
                        <th class="text-center">POD</th>
                        </thead>

                        <!-- Si la tabla no encuentra registros -->
                        <tbody v-if="isEmpty" class="text-center">
                        <td colspan="4">
                          <not-found-table text="Sin registros" sizeText=".75rem" sizeIcon="2rem" />
                        </td>
                        </tbody>

                        <!-- Si la tabla cuenta con registros -->
                        <tbody v-else>
                        <tr>
                          <td class="text-center" v-text="id"></td>
                          <td class="text-center" v-text="cliente"></td>
                          <td class="text-center" v-text="pol"></td>
                          <td class="text-center" v-text="pod"></td>
                        </tr>
                        </tbody>
                      </table>

                      <table-skeleton v-if="isLoading" :numberRows="1" :headers="['Containers en cola', 'Total containers con itinerario']"/>

                      <table v-else class="table table-striped table-hover mt-2 bordeTabla">
                        <thead>
                        <th class="text-center">Containers en Cola</th>
                        <th class="text-center">Total Containers con Itinerario</th>
                        </thead>

                        <!-- Si la tabla no encuentra registros -->
                        <tbody v-if="isEmpty" class="text-center">
                        <td colspan="2">
                          <not-found-table text="Sin registros" sizeText=".75rem" sizeIcon="2rem" />
                        </td>
                        </tbody>

                        <!-- Si la tabla cuenta con registros -->
                        <tbody v-else>
                        <tr>
                          <td class="text-center" v-text="contenedoresEnCola"></td>
                          <td class="text-center" v-text="totalContenedores"></td>
                        </tr>
                        </tbody>
                      </table>



                    </div>
                  </div>

                </div>

              </div>

              <fieldset-component class="mt-4" :texto="'Resultados de '+tituloTxtAux" />

              <table-skeleton v-if="isLoading" :numberRows="1" :headers="['ID', 'Semana', 'Cliente', 'Shipper', 'Naviera', 'Nave', 'POL', 'POD', 'Producto', 'Cantidad', 'Número', 'Estado', 'Acciones']" />

              <table v-else class="table table-striped table-hover mt-3  text-center table-bordered">

                <thead>
                <th class="text-center">ID</th>
                <th class="text-center">Semana</th>
                <th class="text-center">Cliente</th>
                <th class="text-center">Shipper</th>
                <th class="text-center">Naviera</th>
                <th class="text-center">Nave</th>
                <th class="text-center">POL</th>
                <th class="text-center">POD</th>
                <th class="text-center">Producto</th>
                <th class="text-center">Cantidad</th>
                <th class="text-center">N° Booking</th>
                <th class="text-center">Estado</th>
                <th class="text-center">Acciones</th>
                </thead>

                <tbody v-if="bookingsList.length == 0" class="text-center">
                <td colspan="13">
                  <not-found-table text="Sin registros" sizeText=".75rem" sizeIcon="2rem" />
                </td>
                </tbody>

                <tbody v-else>
                <tr v-for="(item, index) in bookingsList" :key="index">
                  <td class="text-center" v-text="item.id_by_country"></td>
                  <td class="text-center" v-text="item.week"></td>
                  <td class="text-center" v-text="item.cliente"></td>
                  <td class="text-center" v-text="item.shipper"></td>
                  <td class="text-center" v-text="item.naviera"></td>
                  <td class="text-center" v-text="item.nave"></td>
                  <td class="text-center" v-text="item.pol"></td>
                  <td class="text-center" v-text="item.pod"></td>
                  <td class="text-center" v-text="item.producto"></td>
                  <td class="text-center" v-text="item.containers_requested"></td>
                  <td class="text-center" v-text="item.carrier_booking_number"></td>
                  <td class="text-center" v-text="item.status"></td>
                  <td class="text-center" >
                    <a class="btn btn-sm icono"  @click="goToBooking(item)">
                      <i :title="'Ir a Booking'" class="fa fas fa-arrow-circle-right text-center" ></i>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>

        </ui-tab>

        <!-- Tab 2 -->
        <ui-tab title="Shipping Instructions" id="2">

          <div class="d-flex flex-column">
            <div>
              <div class="d-flex">
                <div class="w-50 mr-2">
                  <div class="d-flex flex-column mt-2 w-100" >

                    <fieldset-component texto="Parámetros de Búsqueda"/>

                    <div class="d-flex mt-3 w-100">

                      <ui-select
                        class="w-50 ml-2"
                        label="Tipos de Búsqueda (*)"
                        placeholder="Seleccionar"
                        :options="searchTypes"
                        v-model="selectedSearchType"
                        :keys="{value: 'id', label: 'name'}"
                      />

                      <ui-textbox
                        class="w-50 ml-3"
                        enforce-maxlength
                        floating-label
                        help="Máximo 20 caracteres"
                        :label="'Buscar ' + searchTypes[searchTypes.findIndex(x => x.id === selectedSearchType.id)].name"
                        error="Campo requerido"
                        :invalid="invalidSearch"
                        v-model="searchModel"
                        :maxlength="20"
                        @keyup.enter.native="searchSI()"
                      />

                      <Button
                        :size="17"
                        color="#28a745"
                        colorText="#ffffff"
                        tooltip="Buscar Shipping Instruction"
                        icon="fas fa-search"
                        class="mx-4 mt-3"
                        round
                        :width="35"
                        traslate
                        @click.native="searchSI()"
                      />

                    </div>

                  </div>
                </div>
              </div>

              <fieldset-component class="mt-4" :texto="'Resultados de '+ searchTypes[searchTypes.findIndex(x => x.id === selectedSearchType.id)].name" />

              <table-skeleton v-if="isLoading" :numberRows="1" :headers="[
                'ID',
                'Document Version',
                'Shipper',
                'Nave',
                'Naviera',
                'No. Booking',
                'Consignatario',
                'Viaje',
                'POD',
                'POL',
                'Estado',
                'Acciones'
              ]" />

              <table v-else class="table table-striped table-hover mt-3  text-center table-bordered">

                <thead>
                <th class="text-center">ID</th>
                <th class="text-center">Document Version</th>
                <th class="text-center">Shipper</th>
                <th class="text-center">Nave</th>
                <th class="text-center">Naviera</th>
                <th class="text-center">No. Booking</th>
                <th class="text-center">Consignatario</th>
                <th class="text-center">Viaje</th>
                <th class="text-center">POD</th>
                <th class="text-center">POL</th>
                <th class="text-center">Estado</th>
                <th class="text-center">Acciones</th>
                </thead>

                <tbody v-if="shippingInstructionsList.length === 0" class="text-center">
                <td colspan="13">
                  <not-found-table text="Sin registros" sizeText=".75rem" sizeIcon="2rem" />
                </td>
                </tbody>

                <tbody v-else>
                <tr v-for="(item, index) in shippingInstructionsList" :key="index">
                  <td class="text-center" v-text="item.id_shipping"></td>
                  <td class="text-center" v-text="item.document_version"></td>
                  <td class="text-center" v-text="item.shipper"></td>
                  <td class="text-center" v-text="item.nave"></td>
                  <td class="text-center" v-text="item.naviera"></td>
                  <td class="text-center" v-text="item.nro_booking"></td>
                  <td class="text-center" v-text="item.consignatario"></td>
                  <td class="text-center" v-text="item.viaje"></td>
                  <td class="text-center" v-text="item.pod"></td>
                  <td class="text-center" v-text="item.pol"></td>
                  <td class="text-center" v-text="item.status"></td>
                  <td class="text-center" >
                    <a class="btn btn-sm icono"  @click="goToSI(item)">
                      <i :title="'Ir a Booking'" class="fa fas fa-arrow-circle-right text-center" ></i>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

        </ui-tab>

      </ui-tabs>




      <!-- Footer -->
      <div class="d-flex justify-content-between mt-4">

        <Button
            :size="23"
            color="#c12020"
            colorText="#ffffff"
            :width="80"
            :height="35"
            text="Cerrar"
            horizontal
            @click.native="closeModal('buscarReservaModal')"
        />

      </div>

    </ui-modal>

    
  </div>
</template>

<script>

// Vuex
import { mapActions } from "vuex";

// UI Modal
import UiModal from "keen-ui/src/UiModal";
import UiTextbox from "keen-ui/src/UiTextbox";
import UiTabs from "keen-ui/src/UiTabs";
import UiTab from "keen-ui/src/UiTab";

// Componentes
import Button from '../common/Button';
import FieldsetComponent from '../common/FieldsetComponent';
import { buscarReserva, searchSI } from "../../constants/general";
import TableSkeleton from '../common/skeletons/tableSkeleton';
import NotFoundTable from '../common/NotFoundTable';
import {
    getBookingsConfirmadosClienteFiltrados,
    getBookingsDeclaradosFiltrados,
    getBookingsSolicitadosFiltrados,
    verBookingItineraries ,
    getBookingsEmbarcadosFiltrados,
    getBookingsCanceladosFiltrados,
    getBookingsDeclaradosCanceladosFiltrados,
    getVerMisBookingsPorAceptarFiltrados,
    getBookingsPorConfirmarFiltrados
} from '../../constants/lineas';

export default {
  data() {
    return {
      busquedaSeleccionadaModel : 'Por ID de Reserva',
      tituloTxtAux              : 'Por ID de Reserva',
      user                      : null ,
      buscarModel               : '',
      campoVacio                : false,
      tipoSeleccionado          : 'Reserva',
      isLoading                 : false,
      dataReserva               : [],
      acciones                  : [],
      isModalInformacionGeneral : false,
      dataVer                   : [],
      dataInformacionGeneral    : [],
      load                      : false,
      showChangeStatus          : false,        
      dataAceptarBooking        : [],
      isEmpty                   : true,
      id                        : '',
      cliente                   : '',
      pol                       : '',
      pod                       : '',
      contenedoresEnCola        : 0,
      totalContenedores         : 0,
      cantidad                  : 0,
      nBooking                  : '',
      estado                    : '',
      estadoBI                  : '',
      estadoBooking             : '',
      anio                      : '',
      itinerary_id              : '',
      dataDeclarados            : [] ,
      showDeclarados            : false,
      bookingsList              : [],
      routesDeclarados: {
        1 : "/lineas/booking/bookings_declarados",
      },
      routesDeclaradosNoUcc: {
        1 : "/lineas/booking/ver_bookings_por_aceptar",
      },
      routesWithItinerariesNoUcc: {
        1 : "/lineas/booking/bookings_por_confirmar",
        2 : "/lineas/booking/bookings_confirmados",
        3 : "/lineas/booking/bookings_cancelados",
        4 : "/lineas/booking/bookings_por_confirmar",
        5 : "/lineas/booking/bookings_embarcados",
      },
      routesWithItineraries: {
        1 : "/lineas/booking/bookings_solicitados",
        2 : "/lineas/booking/bookings_confirmados",
        3 : "/lineas/booking/bookings_cancelados",
        4 : "/lineas/booking/bookings_solicitados",
        5 : "/lineas/booking/bookings_embarcados",
      },

      //SI
      shippingInstructionsList: [],
      selectedSearchType: { id: 1, name: "Por ID de S.I" },
      searchTypes: [
        { id: 1, name: "Por ID de S.I" },
        { id: 2, name: "Por N° de Booking" },
        { id: 3, name: "Por N° de Contenedor" }
      ],
      searchModel: "",
      invalidSearch: false
    };
  },

  components: {
    UiTabs,
    UiTab,
    UiModal,
    UiTextbox,
    Button,
    FieldsetComponent,
    TableSkeleton,
    NotFoundTable
  },
  
  methods: {

    ...mapActions(["ActionSetZindexModal"]),

    ...mapActions("lineas",[
        "actionSetReservaInformacionGeneralModal",
        'actionSetVisibleModalAceptarBookingDeclaradoBuscarReserva',
        "actionSetDataDatatableBookingsDeclarados",
        'actionSetDataDatatableBookingsSolicitados',
        'actionFilterDataBookingsConfirmados',
        'actionSetDataDatatableBookingsEmbarcados',
        'actionSetDatatableBookingsCancelados',
        'actionSetDataDatatableBookingsDeclaradosCancelados',
        'actionFilterDataVerMisBookingsPorAceptar',
        'actionSetDatatableBookingsPorConfirmar'
    ]),

    //gestion modal de busqueda
    openModal(ref) {
      this.$refs[ref].open();
      this.ActionSetZindexModal(true);
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    abrirModal(){
        this.openModal('buscarReservaModal') ;
    },
    cerrarModal(){
        this.closeModal('buscarReservaModal');
        this.ActionSetZindexModal(false);
    },

    //buscador de SI
    busquedaSeleccionada(seleccionado){
        this.tituloTxtAux = seleccionado;
        let split             = seleccionado.split(' ');
        this.tipoSeleccionado = split[split.length - 1];
    },
    goToBooking( booking ) {

        const { id_by_country, booking_state_id, booking_itinerary_state_id , deleted } = booking ;

        let url = "" ; 

        if( this.user.id_role == 1 || this.user.id_role == 2 || this.user.id_role == 4 || this.user.id_role == 9999 ){
            
            url = booking_itinerary_state_id !== null 
                ? this.routesWithItineraries[ booking_itinerary_state_id ]
                : this.routesDeclarados[ booking_state_id ] ;
        }
        else {
            
            url = booking_itinerary_state_id !== null 
                ? this.routesWithItinerariesNoUcc[ booking_itinerary_state_id ]
                : this.routesDeclaradosNoUcc[ booking_state_id ] ;
        }
      
        deleted == 1 && ( url = "/lineas/booking/ver_Bookings_declarados_cancelados" );

        if( this.$route.path == url ){
            this.validatePath() ;
            this.cerrarModal() ;

        } else {
            url += `?id_by_country=${ id_by_country }` ;
            this.cerrarModal() ;
            this.$router.push( url );
        }
        this.setStateInit() ;
    },

    async validatePath( ){
        
        this.$route.path == '/lineas/booking/bookings_declarados'  && this.setDataDeclarados() ;

        this.$route.path == '/lineas/booking/bookings_solicitados' && this.setDataSolicitados() ;
        
        this.$route.path == '/lineas/booking/bookings_confirmados' && this.setDataConfirmados() ;

        this.$route.path == '/lineas/booking/bookings_embarcados'  && this.setDataEmbarcados() ;

        this.$route.path == '/lineas/booking/bookings_cancelados'  && this.setDataCancelados() ;

        this.$route.path == '/lineas/booking/ver_Bookings_declarados_cancelados'  && this.setDataDeclaradoCancelados() ;
        
        this.$route.path == '/lineas/booking/ver_bookings_por_aceptar' && this.setDataPorAceptar() ;

        this.$route.path == '/lineas/booking/bookings_por_confirmar' && this.setDataPorConfirmar() ;


    },
    setStateInit(){
        this.id      = "" ; 
        this.cliente = "" ; 
        this.pol     = "" ; 
        this.pod     = "" ; 
        this.bookingsList       = [] ;
        this.totalContenedores  = 0;
        this.cantidad           = 0;
        this.isEmpty            = true;
    },
    async realizarBusqueda(){

        if (this.buscarModel.length == 0) {
            
            this.campoVacio = true;
        } else {
            
            this.$vToastify.loader("Obteniendo registros...");
            this.isLoading  = true;
            this.campoVacio = false;

            try {
                const response = await buscarReserva( { tipo: this.tipoSeleccionado, identificador: this.buscarModel } );

                const { data, cantidad, booking, totalContainers } = response.data;
                
                this.bookingsList       = data ;
                this.totalContenedores  = totalContainers;
                this.cantidad           = cantidad;
                this.isEmpty            = false;
                this.isLoading          = false;

                //info base
                this.id      = booking.id_by_country ; 
                this.cliente = booking.client ; 
                this.pol     = booking.pol_name ; 
                this.pod     = booking.pod_name ; 

                this.contenedoresEnCola = booking.containers_requested ;

                this.$vToastify.stopLoader();

            } catch (error) {
                this.setStateInit() ;
                this.$vToastify.stopLoader();
                this.$vToastify.error("No se encontraron registros", "Lo sentimos");
                this.isLoading  = false;
                this.isEmpty    = true;
            }
        }

    },
    async setDataDeclaradoCancelados(){
   
        const filters = {
            id_by_country: this.id ,
            cliente: null,
            producto: null,
            pod: null,
            semana: null,
            anio: ""
        };

        const dataFiltrada = await getBookingsDeclaradosCanceladosFiltrados( filters );

        this.actionSetDataDatatableBookingsDeclaradosCancelados( dataFiltrada ) ;
    },
    async setDataCancelados(){
   
        const filters = {
            id: this.id ,
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            semana_inicio: null,
            semana_termino: null,
            anio: "",
            no_booking: ""
        } ;

      const dataFiltrada = await getBookingsCanceladosFiltrados(filters);

      this.actionSetDatatableBookingsCancelados( dataFiltrada ) ;
    },
    async setDataEmbarcados(){
      
        const filters = {
            id: this.id ,
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            semana_inicio: null,
            semana_termino: null,
            anio: "",
            comercial: null,
            servicio_integral: "",
            t_servicio_integral: null,
            no_booking: "",
            referencia: ""
        }

        const dataFiltrada = await getBookingsEmbarcadosFiltrados(filters);

        this.actionSetDataDatatableBookingsEmbarcados( dataFiltrada ) ;
    },
    async setDataConfirmados(){
      
        const  filters =  {
            id: this.id ,
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            semana_inicio: null,
            semana_termino: null,
            anio: "",
            comercial: "",
            servicio_integral: "",
            t_servicio_integral: null,
            no_booking: "",
            referencia: ""
        } ;

        const dataFiltrada = await getBookingsConfirmadosClienteFiltrados(filters);
        this.actionFilterDataBookingsConfirmados( dataFiltrada ) ;
    },
    async setDataDeclarados(){

        const filters = { 
            id_by_country: this.id ,
            anio : null,
            cliente: null,
            pod : null,
            servicio_integral :"",
            semana: null,
            comercial: null
        };

        const data_table = await getBookingsDeclaradosFiltrados( filters );
        this.actionSetDataDatatableBookingsDeclarados( data_table );        
    },

    async setDataSolicitados(){
        
        const filters = {
            id: this.id ,
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            no_booking: "",
            semana_inicio: null,
            semana_termino: null,
            referencia: "",
            anio: "",
            comercial: null,
            servicio_integral: "",
            t_servicio_integral: null
        } ;

      const data_table = await getBookingsSolicitadosFiltrados( filters );
      this.actionSetDataDatatableBookingsSolicitados( data_table ) ;
    },

    async setDataPorAceptar(){
        
        const filters = {
            id: this.id ,
            anio : null,
            pod  : null,
            semana : null,
            producto : null
        } ;
      
        const dataFiltrada = await getVerMisBookingsPorAceptarFiltrados(filters);
        this.actionFilterDataVerMisBookingsPorAceptar(dataFiltrada);
    },

    async setDataPorConfirmar(){
        
        const filters = {
            id: this.id ,
            referencia: "",
            no_booking: "",
            cliente: null,
            nave: "",
            naviera: null,
            pod: null,
            pol: null,
            semana_inicio: null,
            semana_termino: null,
            anio: ""
        } ;

        const dataFiltrada = await getBookingsPorConfirmarFiltrados(filters);
        this.actionSetDatatableBookingsPorConfirmar(dataFiltrada);
    },

    async cargarVerBookingItineraries(form) {
        const data = await verBookingItineraries(form);
        this.dataVer = data;
    },

    //buscador SIs
    async searchSI(){

      if (this.searchModel === "") {

        this.invalidSearch = true;

        this.$vToastify.error("Ingrese un parámetro de búsqueda...", "Error");

      } else {

        this.$vToastify.loader("Obteniendo registros...");

        this.isLoading  = true;

        this.invalidSearch = false;

        try {

          const { status, shippings } = await searchSI({
            type: this.selectedSearchType.id,
            value: this.searchModel
          });

          if (status === 200) {

            this.shippingInstructionsList = shippings;

            this.isLoading = false;


          } else {

            this.$vToastify.error("Se produjo un error al obtener los registros", "Error");

          }

          this.$vToastify.stopLoader();

        } catch (error) {

          console.log(error)

          this.$vToastify.stopLoader();

          this.$vToastify.error("Se produjo un error al obtener los registros", "Error");

          this.isLoading = false;

          this.isEmpty = true;

        }
      }
    },
    goToSI(si) {

      let url = "";

      url = si.status_info.url;

      url += `?id=${si.id_shipping}`;

      this.cerrarModal();

      this.$router.replace(url);

    }
  },
  mounted() {

    this.user = JSON.parse(localStorage.getItem("user"));

  }
};
</script>

<style ></style>
